import { render, staticRenderFns } from "./BloqueBoton.vue?vue&type=template&id=2767473f&scoped=true"
import script from "./BloqueBoton.vue?vue&type=script&lang=js"
export * from "./BloqueBoton.vue?vue&type=script&lang=js"
import style0 from "./BloqueBoton.vue?vue&type=style&index=0&id=2767473f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2767473f",
  null
  
)

export default component.exports